import AbstractProvidedClass from "../../shared/AbstractProvidedClass";

export default class CustomLabel extends AbstractProvidedClass {
    constructor(provider, { value, visible = true }) {
        super(provider);


        this.text = value;
        this.visible = visible;
    }

    hasLabels() {
        return this.text.length > 0;
    }

    setParent(parent) {
        this.parent = parent;
    }

    getValue() {
        return this.text;
    }

    getValues() {
        return this.visible ? this.text : null;
    }

    clone() {
        return new CustomLabel(this.provider, {
            value: this.text,
            visible: this.visible,
        });
    }

    export() {
        return {
            type: 'custom',
            value: this.text,
            visible: this.visible,
        };
    }

    get index() {
        return this.parent.getIndexOf(this);
    }
}
